import React, { useState } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import OperationPanel from "../../../components/Common/OperationPanel";
import CommonModal from "../../../components/Common/CommonModal";
import DesignationList from "./DesignationList";
import DesignationForm from "./DesignationForm";
import DesignationTabs from "./DesignationTabs";

const Index = () => {
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [tab, setTab] = useState("active");
  const [mode, setMode] = useState("create");
  const [selected, setSelected] = useState(null);

  return (
    <div className="page-content">
      <Breadcrumbs title="Organization" breadcrumbItem="Designations" />

      <OperationPanel
        search={search}
        setSearch={setSearch}
        hideSearch={true}
        addLabel="Add Designation"
        onAdd={() => {
          setMode("create");
          setSelected(null);
          setModal(true);
        }}
      />

      <DesignationTabs tab={tab} setTab={setTab} />

      <DesignationList
        search={search}
        refresh={refresh}
        tab={tab}
        setMode={setMode}
        setSelected={setSelected}
        setModal={setModal}
      />

      <CommonModal
        isOpen={modal}
        toggle={() => setModal(false)}
        title={mode === "edit" ? "Edit Designation" : "Create Designation"}
      >
        <DesignationForm
          mode={mode}
          selected={selected}
          onSuccess={() => {
            setModal(false);
            setRefresh(prev => !prev);
          }}
        />
      </CommonModal>
    </div>
  );
};

export default Index;